import * as Cesium from 'cesium';
import MapUtil from './mapUtil';

/**
 * 轨迹回放
 */
export default class TrackPlayTool {
    constructor(viewer,config) {
        let self=this;
        this._viewer = viewer;
        this._config = config;
        //模型沿着轨迹移动（图标移动过的路径变色）
        viewer.clock.shouldAnimate = false; //停止播放
        let start = Cesium.JulianDate.fromDate(new Date(config.points[0].timestamp)); //获取第一个点的时间
        viewer.clock.startTime = start;  //将多个点的第一个点设为轨迹播放的开始时间
        viewer.clock.currentTime = start; //修改时间轴的当前时间

        let positionProperty = new Cesium.SampledPositionProperty();
        let lastTimestamp=0;
        config.points.forEach((item,index)=>{
            let timestamp = item.timestamp;
            if(index>0){
                timestamp = lastTimestamp+parseInt((item.timestamp-config.points[index-1].timestamp)/config.speed);
            }
            let position = Cesium.Cartesian3.fromDegrees(item.x, item.y,window.viewer.tilesetModel?.altitude||10);
            // 添加每一个链接点的信息，到达的时间以及坐标位置
            positionProperty.addSample(Cesium.JulianDate.fromDate(new Date(timestamp)), position);
            lastTimestamp=timestamp;
        })

        if(config.showTrack){
            //加轨迹线
            this.lineEntity = this._viewer.entities.add({
                polyline:{
                    positions:Cesium.Cartesian3.unpackArray(positionProperty._property._values),
                    width:4,
                    material:new Cesium.Color.fromCssColorString("#ee3434"),
                    //classificationType:Cesium.ClassificationType.CESIUM_3D_TILE,
                    //clampToGround:true
                }
            })
            MapUtil.flyToByEntity(this.lineEntity);
        }

        //设置贴地
        positionProperty.setInterpolationOptions({
            interpolationDegree: 1,//值越大，越平滑，拐角越趋向圆形
            interpolationAlgorithm: Cesium.LagrangePolynomialApproximation
        });

        let times = positionProperty._property._times;
        let startTime = times[0].clone();
        let stopTime = times[times.length - 1].clone();

        //TODO:移动实体对象
        this.positionEntity = this._viewer.entities.add({
            position: Cesium.Cartesian3.unpackArray(positionProperty._property._values)[0],
            // model: {
            //     uri: 'http://data.mars3d.cn/gltf/mars/wrj.glb',
            //     scale: 1,
            //     minimumPixelSize: 20
            // },//model方式 和billboard二选一
            billboard: {
                image: config.image,
                pixelOffset: new Cesium.Cartesian2(0, -10),
                //eyeOffset:new Cesium.Cartesian3(0,0,-10),
                //heightReference: Cesium.HeightReference.CLAMP_TO_GROUND
            },//billboard方式 和model二选一
            label: {
                text: config.name,
                color :Cesium.Color.fromCssColorString('#fff'),
                backgroundColor:Cesium.Color.fromCssColorString('#22d225'),
                backgroundPadding:new Cesium.Cartesian2(7, 5),
                outlineWidth:0,
                font: "14px Helvetica",
                showBackground : true,
                horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
                pixelOffset: new Cesium.Cartesian2(10, -48), // 偏移量
                //eyeOffset:new Cesium.Cartesian3(0,0,-10),
                //heightReference: Cesium.HeightReference.CLAMP_TO_GROUND
            }
        });

        this.pathEntity = this._viewer.entities.add({
            availability: new Cesium.TimeIntervalCollection([new Cesium.TimeInterval({
                start: startTime,
                stop: stopTime
            })]),
            position: positionProperty, // 点集
            orientation: new Cesium.VelocityOrientationProperty(positionProperty),
            path: {
                leadTime: 0,// 设置为0时 模型通过后显示path
                //trailTime: 0,// 设置为0时 模型通过后隐藏path
                resolution: 1,
                material: Cesium.Color.GREEN,
                width: 10
            }
        });

        this._viewer.clock.onStop.addEventListener((tick) => {
          console.log(tick, 'stop')
          // 动画执行到结束时间时调用
          // 逻辑代码 removeEventListener => onTick
        })

        self._viewer.clock.onTick.addEventListener((tick) => {
            if(self._viewer.clock.shouldAnimate === true) {
                let position = positionProperty.getValue(tick.currentTime);//获取位置
                self.positionEntity.position = position;//self._viewer.scene.clampToHeight(position, [self.positionEntity]);//TODO:更新移动实体位置

                if(self._config.viewType==0){//TODO:第一人称
                    let orientation = self.pathEntity.orientation;
                    let ori  = orientation.getValue(self._viewer.clock.currentTime);//获取偏向角
                    let transform = Cesium.Matrix4.fromRotationTranslation(Cesium.Matrix3.fromQuaternion(ori), position);//将偏向角转为3*3矩阵，利用实时点位转为4*4矩阵
                    self._viewer.camera.lookAtTransform(transform, new Cesium.Cartesian3(-10, 0, 0))//将相机向后面放一点
                }
                if(self._config.viewType==1){//TODO:第三人称
                    let orientation = self.pathEntity.orientation;
                    let ori  = orientation.getValue(self._viewer.clock.currentTime);//获取偏向角
                    let transform = Cesium.Matrix4.fromRotationTranslation(Cesium.Matrix3.fromQuaternion(ori), position);//将偏向角转为3*3矩阵，利用实时点位转为4*4矩阵
                    self._viewer.camera.lookAtTransform(transform, new Cesium.Cartesian3(-80, 0, 30))//将相机向后面放一点
                }
                if(self._config.viewType==2){//TODO:跟踪视角
                    let orientation = self.pathEntity.orientation;
                    let ori  = orientation.getValue(self._viewer.clock.currentTime);//获取偏向角
                    let transform = Cesium.Matrix4.fromRotationTranslation(Cesium.Matrix3.fromQuaternion(ori), position);//将偏向角转为3*3矩阵，利用实时点位转为4*4矩阵
                    self._viewer.camera.lookAtTransform(transform, new Cesium.Cartesian3(-200,400,200))//将相机向后面放一点
                }

                let progressValue = Cesium.JulianDate.secondsDifference(startTime, tick.currentTime)/Cesium.JulianDate.secondsDifference(startTime, stopTime);
                config.callback&&config.callback(position,progressValue);

            }
        })
        self._viewer.scene.postRender.addEventListener(function () {
            if(self._viewer.clock.shouldAnimate === true) {
                const position = positionProperty.getValue(self._viewer.clock.currentTime);
                //self.positionEntity.position = self._viewer.scene.clampToHeight(position, [self.positionEntity]);
                //positionProperty.addSample(self._viewer.clock.currentTime,position);
            }
        });
    }

    /**
     * 开始播放
     */
    play() {
        this._viewer.clock.shouldAnimate = true;
    }

    /**
     * 暂停播放
     */
    pause(){
        this._viewer.clock.shouldAnimate = false;
    }

    /**
     * 结束播放
     */
    stop() {
        this._viewer.clock.shouldAnimate = false;
        this._viewer.entities.removeAll();
        let start = Cesium.JulianDate.fromDate(new Date()); //获取第一个点的时间
        this._viewer.clock.startTime = start;  //将多个点的第一个点设为轨迹播放的开始时间
        this._viewer.clock.currentTime = start; //修改时间轴的当前时间

        this._viewer.clock.onStop.removeEventListener((tick) => {
            console.log(tick, 'removeEventListener:stop')
        })
        this._viewer.clock.onTick.removeEventListener((tick) => {
            console.log(tick, 'removeEventListener:tick')
        })

        this._viewer.scene.postRender.removeEventListener(function() {
            console.log('removeEventListener:postRender')
        });
    }

}